<template>
    <div class = "menu_div">
        <div class="row">
            <div class="col-sm-8"><img :src=function_img alt=""></div>
            <div class="col-sm-4 functions">
                <div class="title">
                        <hr width=10%>
                        <h2>{{this.EventBus.getText("function_title")}}</h2>
                        <p>{{this.EventBus.getText("function_text")}}<br>{{this.EventBus.getText("function_text2")}}</p>
                    </div>
                <div class="container">
                    <div class="pointer">
                        <div class="item" v-for="data in datas" v-bind:key="data.index">
                            <div @click="links(data.path)">
                                <div v-if="data.index==1 || data.index==4" class="blue">
                                <img :src="data.img" alt="">
                                <h3>{{data.subject}}</h3>  
                                </div>
                                <div v-if="data.index==2 || data.index==3" class="white">
                                    <img :src="data.img" alt="">
                                    <h3>{{data.subject}}</h3>  
                                </div>
                            </div>
                            
                                                      
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- <h3 class="text-center">기본 기능</h3>
        
        <div class="menu_container" v-for="data in datas" v-bind:key="data.index" >
            <div class="pointer" @click="links(data.path)">

                <p>{{data.subject}}</p>
            </div>
        </div> -->
         <Footer/>
        <js/>
    </div>
</template>
<script>
import Function from '../assets/language/fuction.json'
export default {
    beforeCreate(){
        this.EventBus.loadLanguage(Function);
    },
    // created() {
    //     this.EventBus.loadLanguage(Function);
    // },
    data() {
        return {
            function_img: this.EventBus.getText("function_img"),
            datas: [
                {
                    index: 1,
                    img: '/static/tutorial/functions/intro/screen.png',
                    subject:this.EventBus.getText('function_operation'),
                    path: '/function/screen',
                },
                {
                    index: 2,
                    img: '/static/tutorial/functions/intro/interface.png',
                    subject:this.EventBus.getText("function_interface"),
                    path: '/function/interface',
                },
                {
                    index: 3,
                    img: '/static/tutorial/functions/intro/file.png',
                    subject:this.EventBus.getText("function_file"),
                    path: '/function/file',
                },
                {
                    index: 4,
                    img: '/static/tutorial/functions/intro/shape.png',
                    subject:this.EventBus.getText("function_shape"),
                    path: '/function/shape',
                },
            ]
        }
    },
    methods:{
        links(path){
            window.location.href = path
        }
    }
}
</script>

<style scoped>
    .menu_div{
        padding: 8vw 0;
        /* margin: auto; */
        text-align: center;
        width: 100wh;
    }

    img {
        width: 50vw;
        /* width: 1100px; */
        box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.1);
        border-radius: 20px;
    }
    h2 {
        font-weight: 500;
        font-size: 22px;
        letter-spacing: 0.1rem;
        color: #5E5E5E;
    }

    h3{
        font-size: 15px;
        margin-top: 10px;
    }

    hr{
        border: #25CAD2 solid 3px;
        left: 0;
        margin-left: 0;
    }
    
    p {
        font-size: 15px;
        color: #5E5E5E;
        line-height: 1.5rem;
    }
    .title{
        background-color: #F6F6F6;
        width: 500px;
        height: 350px;
        text-align: left;
        /* padding: 5vw 3vw; */
        padding: 90px;
    }

    .container{
        margin: 0;
        padding: 0;
    }
    .pointer{
        width: 500px;
        height: 300px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        margin: 0;
        padding: 0;
    }

    .item{
        width: 250px;
        height: 150px;
        display: inline-block;
        /* height: 50%; */
        background-color: #85E5E9;
        /* box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.01); */
        /* vertical-align: center; */
        /* padding: 25px; */
    }

    .item p{
        font-weight: 700;
        color: #3D3D3D;
        text-align: center;
        font-size: 17px;

    }

    .item img{
        width: 45px;
        border: none;
        border-radius: 0;
        box-shadow: none;
    }

    .white{
        background-color: white;
        width: 250px;
        height: 150px;
        padding: 40px;   
    }

    .blue{
        padding: 40px;
    }
    .pointer{ cursor: pointer; }
</style>


// WEBPACK FOOTER //
// src/pages/function.vue